import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';
import terminology from 'javascripts/terminology';

export class FeatureName extends Field {
  static subqueriesForModel() {
    return { feature: ['name'] };
  }

  get title() {
    return `${terminology('Features')} name`;
  }

  exampleContents(): FieldContentsData {
    return { text: `Example ${terminology('feature')}` };
  }

  contentsForRecord(record): FieldContentsData {
    return { text: record.feature?.name };
  }
}
